export default {
    'widgets.swap-form.header.swap': 'Intercambiar',
    'widgets.swap-form.input.title.you_pay': 'Tú pagas',
    'widgets.swap-form.input.title.you_receive': 'Tú recibes',
    'widgets.swap-form.input.balance.balance': 'Saldo',
    'widgets.swap-form.fusion-info.slippage-tolerance': 'Tolerancia al deslizamiento',
    'widgets.swap-form.fusion-info.auction-time': 'Tiempo de subasta',
    'widgets.swap-form.fusion-info.min-receive': 'Mínimo recibido',
    'widgets.swap-form.fusion-info.net-fee': 'Tarifa de red',
    'widgets.swap-form.swap-button.confirm-swap': 'Confirmar intercambio',
    'widgets.swap-form.swap-button.update-swap-data': 'Buscando ruta de intercambio',
    'widgets.swap-form.swap-button.check-allowance': 'Verificar autorización',
    'widgets.swap-form.swap-button.native-token-not-supported': 'El token nativo no está soportado actualmente',
    'widgets.swap-form.swap-button.approve-and-swap': 'Aprobar e intercambiar',
    'widgets.swap-form.swap-button.permit-and-swap': 'Permitir e intercambiar',
    'widgets.swap-form.swap-button.connect-wallet': 'Conectar billetera',
    'widgets.swap-form.swap-button.select-source-token': 'Seleccionar token de origen',
    'widgets.swap-form.swap-button.select-destination-token': 'Seleccionar token de destino',
    'widgets.swap-form.swap-button.enter-amount-to-swap': 'Ingresar cantidad a intercambiar',
    'widgets.swap-form.swap-button.no-liquidity-for-swap': 'Sin liquidez para intercambio',
    'widgets.swap-form.swap-button.insufficient-balance': 'Saldo insuficiente de {{symbol}}',
    'widgets.swap-form.swap-button.set-max': 'Establecer máx {{symbol}}',
    'widgets.swap-form.swap-button.wait-wallet-response': 'Esperar respuesta de la billetera',
    'widgets.swap-form.swap-button.permit-swap-in-wallet': 'Permitir intercambio en la billetera',
    'widgets.swap-form.swap-button.allow-swap-in-wallet': 'Permitir intercambio en la billetera',
    'widgets.swap-form.swap-button.wallet-rejected': 'La billetera rechazó la solicitud',
    'widgets.swap-form.swap-button.swap-error-message': 'Error de intercambio',
    'widgets.swap-form.swap-button.waiting-approve-transaction': 'Esperando aprobación de token',
};
//# sourceMappingURL=es.js.map